module.exports = __webpack_public_path__ + "static/img/noContentImg.597a3b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noContentImg.png
// module id = Ip0Z
// module chunks = 3